import axios from '../../axios/axios';
import ipAddress from '../../axios/ipAddress' //域名
import QS from 'qs'; //序列化

/**
 * 商城相关接口
 */
const store = {

    /**
     * 商品相关
     */

     //商品列表
     storeList(current,size,start,name,type){
        return axios.post(ipAddress.qi+'/admin/a1/store-product/page',{
            condition:{
                productName:null,
                name:name,
                type:type
            },
            current: current,
            size: size,
            start: start
        },true)
    },

    //添加商品
    addStore(form){
        return axios.postFrom(ipAddress.qi+'/admin/a1/store-product/save',form)
    },

    //编辑
    updateStore(form){
        return axios.postFrom(ipAddress.qi+'/admin/a1/store-product/updateById',form)
    },

    //删除
    deleteStore(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-product/delete',QS.stringify({
            id:id
        }),false)
    },

    /**
     * 图片相关
     * 
     */
    //图片列表
    storeOne(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-img-intro/getOne',QS.stringify({
            id:id
        }),false)
    },

    //添加图片
    addStoreImg(form){
        return axios.postFrom(ipAddress.qi+'/admin/a1/store-img-intro/save',form)
    },

    //编辑图片
    updateStoreImg(form){
        return axios.postFrom(ipAddress.qi+'/admin/a1/store-img-intro/updateById',form)
    },

    //删除图片
    deleteStoreImg(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-img-intro/delete',QS.stringify({
            id:id
        }),false)
    },

    /**
     * 产品参数
     */

     //参数列表
    parameterOne(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-parameter-bean/getOne',QS.stringify({
            id:id
        }),false)
    },

     //添加
     addParameter(form){
         return axios.post(ipAddress.qi+'/admin/a1/store-parameter-bean/save',form,true)
     },

     //编辑
     updateParameter(form){
        return axios.post(ipAddress.qi+'/admin/a1/store-parameter-bean/updateById',form,true)
    },

    //删除
    deleteParameter(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-parameter-bean/delete',QS.stringify({
            id:id
        }),false)
    },

    /**
     * 产品说明
     */

    //查询
    explainOne(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-description/getOne',QS.stringify({
            id:id
        }),false)
    },
    
    //添加
    addExplain(form){
        return axios.post(ipAddress.qi+'/admin/a1/store-description/save',form,true)
    },

    //编辑
    updateExplain(form){
        return axios.post(ipAddress.qi+'/admin/a1/store-description/updateById',form,true)
    },

    //删除
    deleteExplain(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-description/delete',QS.stringify({
            id:id
        }),false)
    },

    /**
     * 轮播图
     */
    //查询
    slideOne(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-slideshow/getOne',QS.stringify({
            id:id
        }),false)
    },
    
     //添加
     addSlide(form){
        return axios.postFrom(ipAddress.qi+'/admin/a1/store-slideshow/save',form)
    },

    //编辑
    updateSlide(form){
        return axios.postFrom(ipAddress.qi+'/admin/a1/store-slideshow/updateById',form)
    },

    //删除
    deleteSlide(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-slideshow/delete',QS.stringify({
            id:id
        }),false)
    },

    /**
     * 抵扣规则
     */

    //查询
    deductionOne(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-deduction/getOne',QS.stringify({
            id:id
        }),false)
    },

    //添加
    addDeduction(form){
        return axios.post(ipAddress.qi+'/admin/a1/store-deduction/save',form,true)
    },

    //编辑
    updateDeduction(form){
        return axios.post(ipAddress.qi+'/admin/a1/store-deduction/updateById',form,true)
    },

    //删除
    deleteDeduction(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-deduction/delete',QS.stringify({
            id:id
        }),false)
    },


    /***
     * 订单相关
     */
    //商品列表
    orderList(form){
        return axios.post(ipAddress.qi+'/admin/a1/store-order/page',form,true)
    },

    //商品列表
    orderSlide(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-order/getByOid',QS.stringify({
            orderId:id
        }),false)
    },
    //
    orderLogistics(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-order-logistics/getAliLogistics',QS.stringify({
            orderId:id
        }),false)
    },
    //快递列表
    express(){
        return axios.post(ipAddress.qi+'/admin/a1/logistics-company/list',null,false)
    },
    //添加快递
    addExpress(form){
        return axios.post(ipAddress.qi+'/admin/a1/store-order-logistics/save',form,true)
    },

    addExpressX(){
        return axios.post(ipAddress.qi+'/admin/a1/store-order-logistics/save',form,true)
    },

    //判断是否退款
    refundInfo(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-order/getRefundInfo',QS.stringify({
            id:id
        }),false)
    },

    //确认退款
    sendRefund(form){
        return axios.post(ipAddress.qi+'/admin/a1/store-order/affirmRefund',form,true)
    },

    //修改物流
    updateExpress(form){
        return axios.post(ipAddress.qi+'/admin/a1/store-order-logistics/updateById',form,true)
    },



    /**
     * 礼品相关
     */
    //礼品类型
    selectPresentType(){
        return axios.post(ipAddress.qi+'/admin/a1/store-gift-type/list',null,false)
    },

    //代金券类型
    selectVoucher(){
        return axios.post(ipAddress.qi+'/admin/a1/vip-coupon/list',null,false)
    },
    //添加礼品
    addStorePresent(form){
        return axios.post(ipAddress.qi+'/admin/a1/store-gift/save',form,true)
    },
    //界面
    selectPresent(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-gift/list',QS.stringify({
            pid:id
        }),false)
    },
    //删除
    deletePresent(id){
        return axios.post(ipAddress.qi+'/admin/a1/store-gift/delete',QS.stringify({
            id:id
        }),false)
    }
}
export default store;


// WEBPACK FOOTER //
// ./src/js/store/store.js